import React from "react";

import { mdiPencil } from "@mdi/js";
import Icon from "@mdi/react";
import classNames from "classnames";

import { prettifyDistributionFormat } from "../../../utils/fast";

import type { JSX } from "react";

import type { DistributionFormat } from "../../../constants/fast";

interface IBroadcastCard {
  logoUrl: string;
  name: string;
  distributionFormat: DistributionFormat;
  isActive: boolean;
  onClick: (id: string) => void;
  id: string;
  onEditClick?: () => void;
}

function BroadcastCard({
  logoUrl,
  name,
  distributionFormat,
  isActive,
  onClick,
  id,
  onEditClick,
}: IBroadcastCard): JSX.Element {
  const containerClassNames = classNames(
    "rounded-[0.3125rem] bg-card drop-shadow cursor-pointer",
    { "border-primary border-2": isActive },
  );

  const headerCardClassNames = classNames(
    "flex items-center gap-[0.78125rem] border-b p-[0.78125rem] rounded-t-lg",
    { "bg-primary/10 border-primary": isActive },
    { "border-2 border-card border-b-border": !isActive },
  );

  const bodyCardClassNames = classNames("p-[0.78125rem]", {
    "border-x-2 border-b-2 border-card rounded-b-lg": !isActive,
  });

  const handleEditClick = (e: React.MouseEvent): void => {
    e.stopPropagation();
    onEditClick?.();
  };

  return (
    <div className={containerClassNames} onClick={(): void => onClick(id)}>
      <div className={headerCardClassNames}>
        <div
          className="size-7.5 bg-contain bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${logoUrl})`,
          }}
        />
        <p className="text-[1.171875rem]">{name}</p>
        {onEditClick ? (
          <button
            className="text-muted-foreground hover:text-muted-foreground mr-1 ml-auto"
            onClick={handleEditClick}
            type="button"
          >
            <Icon path={mdiPencil} size={0.8} />
          </button>
        ) : null}
      </div>
      <div className={bodyCardClassNames}>
        <span className="text-[1.171875rem] uppercase">
          {prettifyDistributionFormat(distributionFormat)}
        </span>
      </div>
    </div>
  );
}

export default BroadcastCard;
